("use strict");
(function () {
  if (!customElements.get("fn-modal")) {
    class FnModal extends HTMLElement {
      constructor() {
        super();
        this.summary = null;
        this.content = null;
        this.contentWrapper = null;
      }
      connectedCallback() {
        this.setupElements();
        this.attachEventListeners();
      }
      disconnectedCallback() {
        if (this.summary) {
          this.summary.removeEventListener(
            "click",
            this.handleSummaryClick.bind(this),
          );
        }
        if (this.content) {
          this.content.removeEventListener(
            "click",
            this.handleContentClick.bind(this),
          );
        }
      }
      setupElements() {
        this.summary = this.querySelector(".fn-modal__summary");
        this.content = this.querySelector(".fn-modal__content");
        this.contentWrapper = this.querySelector(".fn-modal__content-wrapper");
        if (!this.summary || !this.content) {
          console.warn(
            "FnModal: Missing required elements (.fn-modal__summary or .fn-modal__content)",
          );
        }
      }
      attachEventListeners() {
        if (this.summary) {
          this.summary.addEventListener(
            "click",
            this.handleSummaryClick.bind(this),
          );
          this.summary.style.cursor = "pointer"; // Visual feedback
        }
        if (this.content) {
          this.content.addEventListener(
            "click",
            this.handleContentClick.bind(this),
          );
        }
      }
      handleSummaryClick() {
        if (this.content) {
          this.content.classList.toggle("active");
          this.summary.classList.toggle("active");
        }
      }
      handleContentClick(e) {
        // Close modal only if clicking on the overlay (content), not the wrapper
        if (e.target === this.content) {
          this.content.classList.remove("active");
          this.summary.classList.remove("active");
        }
      }
      setActive(isActive) {
        if (this.content) {
          isActive
            ? this.content.classList.add("active")
            : this.content.classList.remove("active");
        }
        if (this.summary) {
          isActive
            ? this.summary.classList.add("active")
            : this.summary.classList.remove("active");
        }
      }
      isActive() {
        return this.content?.classList.contains("active") || false;
      }
    }
    customElements.define("fn-modal", FnModal);
  }
})();
